import type { EmailDesign } from "../../../../email-design/server/supabase-email-design-service";
import type { PollWithOptions } from "../../../../poll/server/supabase-poll-service";

export function calculateButtonWidthForPoll(
  options: PollWithOptions["poll"]["options"],
  paperSize: number,
  // Can be undefined if the account is new.
  buttonSettings?: Pick<
    NonNullable<EmailDesign["button_settings"]>["primary_button"],
    "font_size" | "border"
  >,
): number {
  // The button width should be calculated dynamically based on the font size and
  // longest option text. It should not exceed the paper size. It should be a minimum of 80px.
  const fontSize = buttonSettings?.font_size || 14;
  const border = buttonSettings?.border || 1;
  const buttonPadding = 2; // Assuming some padding around the button

  const scale = fontSize + border + buttonPadding * 1.5;

  const val = Math.max(
    100,
    Math.min(Math.max(...options.map((option) => option.text.length * scale)), paperSize),
  );

  return val;
}
